import React, {Component} from 'react';

import Search from "../core/Search";

class Flotte extends Component {

    constructor(props) {
        super(props);

        this.externalCall = this.externalCall.bind(this);
    }

    externalCall(method) {
        if (method === "addBateau") {
            this.props.history.push('/admin/bateau/');
        }
    }

    render() {
        return (
            <Search
                initData={{DATAGRID_SCREEN_ID: 101}}
                externalCall={this.externalCall} />
        );
    }
}

export default Flotte;
